import React, { useEffect, useRef } from 'react';

import { type HTMLMotionProps, useScroll } from 'framer-motion';

import { type Collection } from '@pkg/graphql/codegen/graphql';

import { ActivityList, type ActivityListProps } from '../ActivityList';
import { MobileCloseButton } from '../MobileCloseButton';
import { TopControls } from '../TopControls';

import { Wrapper } from './styles';

export type MaximizedProps = HTMLMotionProps<'div'> &
    ActivityListProps & {
        collectionData?: Collection;
        handleToggle: () => void;
        onIsScrolled?(scrolled: boolean): void;
        slug?: string;
    };

export const Maximized = ({
    handleToggle,
    pastActivity,
    collectionData,
    variant,
    dead,
    onIsScrolled,
    collectionAddresses,
    activeWalletNumber,
    activityFeed,
    transitionFeed,
    newActivityCounter,
    slug,
    isLoading,
    ...props
}: MaximizedProps) => {
    const scrollRef = useRef<HTMLDivElement>(null);

    const { scrollY } = useScroll({
        container: scrollRef,
    });

    useEffect(() => {
        scrollY.on('change', (y) => {
            if (y > 0) onIsScrolled?.(true);
            else onIsScrolled?.(false);
        });
    }, [onIsScrolled, scrollY]);

    return (
        <>
            <Wrapper $showCompact={variant !== 'detail-view' && variant !== 'collection'} {...props}>
                <TopControls handleToggle={handleToggle} variant={variant} collectionData={collectionData} />
                <ActivityList
                    dead={dead}
                    isLoading={isLoading}
                    collectionData={collectionData}
                    activityFeed={activityFeed}
                    newActivityCounter={newActivityCounter}
                    transitionFeed={transitionFeed}
                    pastActivity={pastActivity}
                    activeWalletNumber={activeWalletNumber}
                    ref={scrollRef}
                    variant={variant}
                    scrollRef={scrollRef}
                    collectionAddresses={collectionAddresses}
                />
            </Wrapper>
            <MobileCloseButton />
        </>
    );
};
